import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  DataService,
  MedicalTestService,
} from '../../services';
import { MedicalTest, OtherServices } from '../../models';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  cartItems: MedicalTest[] = [];
  medicalTests: MedicalTest[] = [];
  isConsultationVisible: boolean = true;
  isMobile: boolean = false;
  consultationService: OtherServices;

  constructor(
    private router: Router,
    private dataService: DataService,
    private medicalTestService: MedicalTestService,
  ) { }

  ngOnInit(): void {
    this.medicalTestService.getMedicalTests().subscribe(
      medicalTests => {
        this.medicalTests = medicalTests as MedicalTest[];
        this.dataService.saveAllLocalMedicalTests(this.medicalTests);
    });
    this.cartItems = JSON.parse(localStorage.getItem('cartItems') || '[]');
  }

  // @HostListener('window:resize', [])
  // onResize() {
  //   // TODO: Use this function to add a 'How can I help you' button
  //   this.isMobile = window.innerWidth < 768;
  // }

  handleSearch(searchCriteria: any) {
    this.router.navigateByUrl('/medical-tests');
  }  

  openConsultation() {
    this.isConsultationVisible = true;
  }

  closeConsultation() {
    this.isConsultationVisible = false;
  }

  goToConsultationService() {
    const services: OtherServices[] = this.dataService.getOtherLocalServices();
    this.dataService.saveLocalDataToView(services[0]);
    this.router.navigate(['single-service-details']);
  }

}